import React from 'react';
import { Dropdown, DisplayText } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';

interface SiteOption {
  label: string;
  value: string;
}

interface SiteSelectorProps {
  siteOptions: SiteOption[];
  loading: boolean;
  error: any;
  value?: string;
  onChange?: (value: string) => void;
}

export const SiteSelector: React.FC<SiteSelectorProps> = ({
  siteOptions,
  loading,
  error,
  value,
  onChange
}) => {
  const handleChange = (value: SiteOption | null) => {
    onChange?.(value?.value || '');
  };
  const selectedOption = siteOptions.find((option) => option.value === value);
  return (
    <div className="flex actr g20">
      <div className="flex actr g10">
        <SVGIcon name="Location" />
        <div className="w200">
          <DisplayText size="large" isRequired>
            <FormattedMessage id="import.title.site" />
          </DisplayText>
        </div>
      </div>
      <div className="w300">
        <Dropdown
          classNamePrefix="value_selector"
          placeholder={
            <FormattedMessage id="rmm.agentDownload.modal.sitePlaceholder" />
          }
          options={siteOptions}
          isLoading={loading}
          isDisabled={loading || !!error}
          value={selectedOption}
          onChange={handleChange}
          styles={{
            menuPortal: (base: any) => ({
              ...base,
              zIndex: 9999
            }),
            menu: (base: any) => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>
    </div>
  );
};
